import { createContext } from 'react';

export const ZoomerContext = createContext(1);
